<template>
    <div class="container">

 
            <div class="row">
              <h1 class="w-100">
      <b-icon icon="people-fill"></b-icon>  Advice

  <div class="float-right" style="margin-top: -62px;"> <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button> 
       </div>
         <help id="15" />
    </h1>

<div class="col-md-12 col-sm-12">
  <!-- <div class="panal mt-20" v-if="item.MessageType == 'Need Advisor'">
           <div class="panal-header">Send to Advisor</div>
          <div class="panal-body">

          <b-alert show>
                 <h1>{{item.MessageType}}</h1>
             
             <h6>Advice  Description </h6>
                  {{item.Advice}}
                  {{item.AdviceDate}}
                   {{item.Advisor}}

          </b-alert>
            <div class="clearfix"></div>
          </div>
        </div> -->

         <div class="panal mt-20" >
          
           <div class="panal-header">General Advice</div>
            <div  >
                                    <b-card  class="col-md-12 col-sm-12 select mb-5 mt-5" text-variant="black" border-variant="primary" sm="12" v-if="empty" >
   No Data
   </b-card>
              <div v-else class="panal-body "  v-for="item in GeneralAdvice" v-bind:Key="item.Serial">
 
                <div class="bodymessage" >

                  <div class="messageTitle">{{item.Advisor}}</div>
                   <div class="text-right">Date: <span class=" text-success">{{item.AdviceDate}}</span></div>
                    <h6>Advice  Description </h6>
                     {{item.Advice}}
 
                   <!-- <div class="mt-4">Advisor:  <span class=" text-success">{{item.Advisor}}</span></div> -->
                   <div class="text-right">
                   <button class="btn btn-success "  @click="GetAdvisesNote(item.Serial) , isShow = ! isShow">Note</button>
                   </div>
                   <div class="note mt-3" v-show="isShow && Serial == item.Serial">
                    
   <div v-for="(item,index) in note" v-bind:Key="index">
 <b-alert show  >
    <div class="text-right" v-if="item.Comment !== 'No Notes Found'">Date: <span class=" text-success">{{item.NoteDate}}</span></div>
 {{item.Comment}}
  
    <div class="mt-4" v-if="item.Comment !== 'No Notes Found'">Advisor: <span class=" text-success">{{item.AcademicName}}</span></div>
 </b-alert>
</div>
                   
                   </div>
                </div>
       
            <div class="clearfix"></div>
          </div>

        </div>
         </div>
            <div class="clearfix"></div>
      



        
        <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>
    </div>





</div>
<div class="col-md-12 mb-5 text-right">
<button class="btn btn-primary " @click="()=>$router.push('/Adviser')">Back to advisor</button>
</div>
</div>
</template>





<script>
    import studentData from '../../services/student/studentDataServices';
import Help from '../Help.vue';
    export default {
  components: { Help },
        name: 'GeneralAdvice',
        data(){
            return{
                GeneralAdvice: [], 
                message:'',
                isLoading : true, 
                successful : false,
               empty : true,
               isShow: false,
               Serial:'',
               note:[]
            }
        }, computed:{
           currenUser(){
            return  this.$store.state.auth.user
          }
       },
       mounted(){
         //this.currenUser.StudentID
         // 131
          //  studentData.GetAcademicAdvice(this.currenUser.StudentID).then(Response =>{
          //      this.isLoading = false ;
          //      this.GeneralAdvice = Response.data
          //      this.empty = false;
          //       // eslint-disable-next-line no-console
          //         // console.log(Response.data)
          //  }, error => {
              
          //         // eslint-disable-next-line no-console
          //         // console.log(error.response.status)
          //        this.empty = true;
          //     this.message =
          //       (error.response && error.response.data && error.response.data.Message) ||
          //       error.message ||
          //       error.toString();
                
          //       if(error.response.status == 404) this.message =''
          //       this.successful = false
          //   }),
            //  ,34
              studentData.Student_Advises_Get(this.currenUser.StudentID ,0).then(Response =>{
               this.isLoading = false ;
               this.GeneralAdvice = Response.data
               this.empty = false;
               if( this.GeneralAdvice.length == 0) this.empty =true
                // eslint-disable-next-line no-console
                  // console.log(Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 this.empty = true;
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
                this.successful = false
            })
            
       },
      methods:{
        GetAdvisesNote(serial){
          
          studentData.Student_Advises_Notes_Get(serial).then(Response =>{
         this.isLoading = false ;
         if(Response.data.length != 0 ){

           this.note = Response.data
           this.empty = false;
           //this.isShow =true 
    this.Serial = serial
         }else{
           this.note =[
          //  AcademicName: "----", 
          {
              Comment: "No Notes Found",
            }] 
            //  NoteDate: "-----"
               this.empty = false;
           //this.isShow =true 
    this.Serial = serial
         }
          // eslint-disable-next-line no-console
            // console.log(Response.data)
     }, error => {
        
            // eslint-disable-next-line no-console
            // console.log(error.response.status)
           this.empty = true;
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
          
          if(error.response.status == 404) this.message =''
          this.successful = false
      }) 
        }
      }
       

    };
</script>










<style >
.note{
  margin: 20px 50px;
}
.alert-info {
    color: #0c5460;
    background-color: #fff7d3;
    border-color: #fbeba7;
}

.bodymessage{
  background: #eeeeee;
  border-radius: 10px;
  margin: 20px 50px;
  padding: 20px;
  position: relative;
}
.messageTitle{
  background: #57A3F1;
    width: 300px;
    padding: 5px;
    color: #fff;
    margin-top: -34px;
    position: absolute;
    border-radius: 5px;
    padding-left: 20px;
    font-weight: 700;

}
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #50BD77;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
.text-black{
  color:black
}


</style>